export default "__VITE_ASSET__ChxE0VF8__"